<template>
  <section class="content checkout-content d-flex justify-content-center">
    <div class="clientauth-wrapper">
      <div class="resetpassword-wrapper">
        <h1 class="modal-title login-modal-title"
            id="exampleModalLongTitle"
												data-test="forgotPasswordHeading"
        >
          {{forgotPasswordFormHeaderText}}
        </h1>
							<request-reset-password-form />
      </div>
    </div>
  </section>
</template>

<script>
import tenantSpecificNames from '../../../commonJs/tenantSpecificNames'
import RequestResetPasswordForm from './forms/ForgotPasswordForm'

export default {
	name: 'forgot-password',
	components: {
		RequestResetPasswordForm
	},
	data () {
		return {
			forgotPasswordFormHeaderText: ''
		}
	},
	mounted () {
		this.forgotPasswordFormHeaderText = tenantSpecificNames.forgotPasswordFormHeaderText
	}
}
</script>

<style scoped>
</style>
